import React, { useEffect, useState } from "react";
import { CustomeStyle } from "../Css/CustomeStyle";
import Footer from "../Fotter";
import { useNavigate } from "react-router-dom";
import fliptwirlsLogo from "../assets/flip-removebg-preview.png";
import { useDispatch, useSelector } from "react-redux";
import { CheckoutApi } from "../redux/slices/CheckoutSlice";
import { viewCartData } from "../redux/slices/ViewCartSlice";

const Checkout = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { ViewCart } = useSelector((state) => state.viewCart);
  const [selectedPayment, setSelectedPayment] = useState(null);
  const [loading, setLoading] = useState(false);
  
  const [guestDetails, setGuestDetails] = useState({
    firstName: "",
    lastName: "",
    companyName: "",
    country: "India",
    streetAddress: "",
    houseNumber: "",
    apartment: "",
    city: "",
    state: "Madhya Pradesh",
    pinCode: "",
    phone: "",
    email: "",
    shippingAddress: false,
    orderNotes: "",
    platform: "website",
  });
  
  useEffect(() => {
    const handlePageShow = (event) => {
      if (event.persisted) {
        dispatch(viewCartData());
      }
    };

    dispatch(viewCartData());
    window.addEventListener("pageshow", handlePageShow);
    
    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, [dispatch]);

  const handleCheckout = () => {
    const Token = localStorage.getItem("authToken");

    if (
      !guestDetails.firstName ||
      !guestDetails.lastName ||
      !guestDetails.streetAddress ||
      !guestDetails.houseNumber ||
      !guestDetails.city ||
      !guestDetails.state ||
      !guestDetails.pinCode ||
      !guestDetails.phone ||
      !guestDetails.email
    ) {
      alert("Error: Please fill in all required fields.");
      return;
    } else if (selectedPayment == null) {
      alert("Error: Please Select Payment Method");
    } else {
      if (Token) {
        setLoading(true);
        const billingAddress = {
          firstName: guestDetails?.firstName,
          lastName: guestDetails?.lastName,
          email: guestDetails?.email,
          streetAddress: guestDetails?.streetAddress,
          city: guestDetails?.city,
          state: guestDetails?.state,
          pinCode: guestDetails?.pinCode,
          phone: guestDetails?.phone,
          paymentMethod: selectedPayment,
        };
        dispatch(CheckoutApi(billingAddress))
          .unwrap()
          .then((response) => {
            navigate("/OrderPlace", { state: { data: response } });
          })
          .catch((error) => {
            console.error("Error placing order:", error);
            alert("Failed to place order. Please try again.");
          })
          .finally(() => {
            setLoading(false);
          });
      } else {
        alert("Please login to continue.");
      }
    }
  };

  useEffect(() => {
    const script1 = document.createElement("script");
    script1.src = "https://www.googletagmanager.com/gtag/js?id=AW-16647750621";
    script1.async = true;
    document.head.appendChild(script1);

    script1.onload = () => {
      const script2 = document.createElement("script");
      script2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', 'AW-16647750621');
        `;
      document.head.appendChild(script2);
    };

    return () => {
      const scripts = document.querySelectorAll(
        'script[src="https://www.googletagmanager.com/gtag/js?id=AW-16647750621"]'
      );
      scripts.forEach((script) => script.remove());
    };
  }, []);

  useEffect(() => {
    if (window.gtag && ViewCart?.finalPrice) {
      window.gtag("event", "conversion", {
        send_to: "AW-16647750621/zBwdCKHYjcEaEN2HooI-",
        value: ViewCart?.finalPrice?.toFixed(2),
        currency: "INR",
        transaction_id: "",
      });
    }
  }, [ViewCart]);

  // 🚀 2. Agar cart khali hai ya session invalid hai, toh user ko warning modal dikhakar Cart par bhej do
  if (!ViewCart?.cartItems || ViewCart?.cartItems?.length === 0) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center bg-gray-100 px-4">
        <div className="bg-white p-8 rounded-2xl shadow-xl max-w-md w-full text-center border border-gray-200">
          <div className="text-orange-500 text-5xl mb-4">⚠️</div>
          <h2 className="text-2xl font-bold text-gray-800 mb-2">Cart is Empty</h2>
          <p className="text-gray-600 mb-6">
            Your session has expired or there are no items in your cart. Please proceed from the cart to checkout.
          </p>
          <button
            onClick={() => navigate("/cart", { replace: true })}
            className="w-full py-3 bg-orange-500 text-white font-semibold rounded-lg hover:bg-orange-600 transition duration-300 shadow-md"
          >
            Go to Cart
          </button>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div className="flex justify-center mb-[-20px]">
        <img src={fliptwirlsLogo} alt="Fliptwirls Logo" className="h-32" />
      </div>
      <h1 className="text-4xl font-bold text-center text-gray-800 mb-8">
        Checkout
      </h1>
      <div className="flex flex-col md:flex-row min-h-screen w-full sm:w-[95%] md:w-[95%] mx-auto p-4 rounded-lg bg-gray-50">
        <div className="h-[20%] w-full md:w-[50%] bg-white p-6 rounded-lg shadow-sm">
          <h2 className="text-2xl font-semibold mb-5 text-gray-700">
            Billing Information
          </h2>
          <div className="flex flex-col gap-1">
            <div className="flex gap-5">
              <input
                type="text"
                placeholder="First Name *"
                value={guestDetails.firstName}
                onChange={(e) =>
                  setGuestDetails({
                    ...guestDetails,
                    firstName: e.target.value,
                  })
                }
                className={`${CustomeStyle.inputBox} w-full md:w-[48%] `}
              />
              <input
                type="text"
                placeholder="Last Name *"
                value={guestDetails.lastName}
                onChange={(e) =>
                  setGuestDetails({ ...guestDetails, lastName: e.target.value })
                }
                className={`${CustomeStyle.inputBox} w-full md:w-[48%]`}
              />
            </div>
            <select
              value={guestDetails.country}
              onChange={(e) =>
                setGuestDetails({ ...guestDetails, country: e.target.value })
              }
              className={CustomeStyle.inputBox}
            >
              <option value="India">India</option>
            </select>
            <input
              type="text"
              placeholder="Street Address *"
              value={guestDetails.streetAddress}
              onChange={(e) =>
                setGuestDetails({
                  ...guestDetails,
                  streetAddress: e.target.value,
                })
              }
              className={CustomeStyle.inputBox}
            />
            <input
              type="text"
              placeholder="House Number *"
              value={guestDetails.houseNumber}
              onChange={(e) =>
                setGuestDetails({
                  ...guestDetails,
                  houseNumber: e.target.value,
                })
              }
              className={CustomeStyle.inputBox}
            />
            <input
              type="text"
              placeholder="Apartment, Suite, Unit, etc. (Optional)"
              value={guestDetails.apartment}
              onChange={(e) =>
                setGuestDetails({ ...guestDetails, apartment: e.target.value })
              }
              className={CustomeStyle.inputBox}
            />
            <div className="flex gap-5">
              <input
                type="text"
                placeholder="City *"
                value={guestDetails.city}
                onChange={(e) =>
                  setGuestDetails({ ...guestDetails, city: e.target.value })
                }
                className={`${CustomeStyle.inputBox} w-full md:w-[48%]`}
              />
              <input
                type="text"
                placeholder="State *"
                value={guestDetails.state}
                onChange={(e) =>
                  setGuestDetails({ ...guestDetails, state: e.target.value })
                }
                className={`${CustomeStyle.inputBox} w-full md:w-[48%]`}
              />
            </div>
            <input
              type="number"
              placeholder="PIN Code *"
              value={guestDetails.pinCode}
              onChange={(e) =>
                setGuestDetails({ ...guestDetails, pinCode: e.target.value })
              }
              className={CustomeStyle.inputBox}
            />
            <input
              type="tel"
              placeholder="Phone *"
              value={guestDetails.phone}
              onChange={(e) =>
                setGuestDetails({
                  ...guestDetails,
                  phone: e.target.value.replace(/[^0-9]/g, ""),
                })
              }
              className={CustomeStyle.inputBox}
            />
            <input
              type="email"
              placeholder="Email Address *"
              value={guestDetails.email}
              onChange={(e) =>
                setGuestDetails({ ...guestDetails, email: e.target.value })
              }
              className={CustomeStyle.inputBox}
            />
          </div>

          <div className="mt-6">
            <label className="text-lg text-gray-600 mb-5 block">
              <input
                type="checkbox"
                checked={guestDetails.shippingAddress}
                onChange={(e) =>
                  setGuestDetails({
                    ...guestDetails,
                    shippingAddress: e.target.checked,
                  })
                }
                className="mr-2"
              />
              Ship to a different address?
            </label>
            <textarea
              placeholder="Order Notes (Optional)"
              value={guestDetails.orderNotes}
              onChange={(e) =>
                setGuestDetails({ ...guestDetails, orderNotes: e.target.value })
              }
              className="block w-full p-3 mb-6 text-lg border border-gray-300 rounded-lg bg-gray-50 h-32"
            />
          </div>
        </div>
        
        <div className="h-full w-[100%] md:w-[50%] bg-white p-5 rounded-lg shadow-sm mt-6 md:mt-0 ml-0 md:ml-8">
          <h2 className="text-2xl font-semibold mb-5">Your Order</h2>
          {ViewCart?.cartItems && ViewCart?.cartItems?.length > 0 ? (
            <>
              <div className="flex justify-between pb-2 mb-1 text-gray-500 font-medium">
                <span className="w-[45%]">Item</span>
                <span>Sale Price</span>
                <span>Qty</span>
                <span>Price</span>
              </div>

              {ViewCart?.cartItems.map((item, index) => {
                return (
                  <div key={index} className="mb-4">
                    <div className="flex justify-between">
                      <span className="font-semibold text-gray-700 w-[50%] overflow-hidden line-clamp-3">
                        {item?.title}
                      </span>
                      <span className="text-gray-600">{item.price}</span>
                      <span className="text-gray-600">{item.quantity}</span>
                      <span className="font-semibold text-blue-500">
                        ₹{item.finalPrice}
                      </span>
                    </div>
                    <div className="flex justify-between font-semibold mt-1 text-gray-600">
                      <span>Shipping Charges</span>
                      <span className="text-black font-semibold">
                        ₹ {ViewCart?.shippingCost}
                      </span>
                    </div>
                    {item?.appliedCoupon && (
                      <div className="rounded-lg border-b mb-5 pb-5">
                        <span className="text-black text-xs font-semibold">
                          Apply Coupons:
                        </span>
                        <div className="text-gray-600">
                          <span className="text-xs font-semibold text-black">
                            Discount:{" "}
                          </span>
                          <span className="text-xs text-black font-semibold ms-2">
                            {item?.appliedCoupon?.discountType == "fixed" &&
                              "₹"}
                            {item?.appliedCoupon?.discountValue}{" "}
                            {item?.appliedCoupon?.discountType == "fixed"
                              ? ""
                              : "%"}
                          </span>
                        </div>
                        <div className="flex items-center gap-2">
                          <span className="text-xs font-semibold text-black">
                            Discount Price:
                          </span>
                          <span className="text-xs font-semibold text-black">
                            ₹{item?.finalPrice}
                          </span>
                          <span className="text-xs line-through text-gray-500">
                            ₹{item?.totalBeforeCoupon}
                          </span>
                        </div>
                      </div>
                    )}
                  </div>
                );
              })}
            </>
          ) : (
            <p>No items in the cart.</p>
          )}

          <div className="flex justify-between font-semibold text-xl border-gray-200">
            <span>Total</span>
            <span>₹{ViewCart?.finalPrice?.toFixed(2)}</span>
          </div>

          <div className="max-w-2xl mx-auto p-3 bg-white shadow-lg rounded-lg border mt-2 border-gray-100">
            <div>
              <h3 className="font-semibold text-lg mb-2">Payment Method</h3>
              <p className="text-sm text-gray-600">
                Pay securely by Credit or Debit card or Internet Banking through
                our secure server.
              </p>
            </div>

            <section className="mt-4">
              <h2 className="font-semibold text-lg mb-2">Payment Options</h2>
              <div className="flex flex-col sm:flex-row sm:space-x-4 mt-2">
                <label
                  className="flex items-center space-x-2 p-3 border rounded-lg w-full sm:w-auto cursor-pointer"
                  onClick={() => setSelectedPayment("COD")}
                >
                  <input
                    type="radio"
                    name="payment"
                    className="w-4 h-4 text-orange-600 focus:ring-orange-500"
                    checked={selectedPayment === "COD"}
                    readOnly
                  />
                  <span className="text-lg text-gray-700">
                    Cash on Delivery
                  </span>
                </label>
              </div>
            </section>

            <section className="mt-4 mb-2">
              <label className="flex items-center space-x-2 cursor-pointer">
                <input type="checkbox" className="h-4 w-4 text-green-600" />
                <span className="text-sm">
                  I agree to the{" "}
                  <a href="#" className="text-blue-600 underline">
                    Terms and Conditions
                  </a>
                </span>
              </label>
            </section>
          </div>

          <button
            onClick={handleCheckout}
            disabled={loading}
            className="mt-4 w-full py-3 text-xl bg-orange-400 text-white rounded-lg hover:bg-orange-700 transition duration-300"
          >
            {loading ? "PROCESSING..." : "Confirm Order"}
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Checkout;